type OrganizationWithSystem = {
  system?: boolean;
};

export function getEmployerVisibleOrganizations<
  T extends OrganizationWithSystem,
>(organizations: T[]): T[] {
  return organizations.filter((organization) => !organization.system);
}
